import React from 'react'
import { useIntl } from 'react-intl'

import {
  Container,
} from './Common'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import type { TourItem } from 'tripPlanner/types/tripItem'
import { isCustomItem } from 'tripPlanner/utils'
import useOffer from 'hooks/Offers/useOffer'
import CustomTour from './CustomTour'
import LuxTour from './LuxTour'

interface Props {
  item: TourItem
}

const TourSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ item }: Props, ref) => {
    const intl = useIntl()
    const { sourceType, code } = item

    const [offer, isLoading] = useOffer<App.Offer | App.Tours.TourV2Offer>(code)

    return (
      <Container ref={ref}>
        {isCustomItem(item) && <CustomTour item={item} />}
        {sourceType === 'LE_Tour' && offer && (
          <LuxTour item={item} offer={offer} />
        )}
        {isLoading && sourceType === 'LE_Tour' && <LoadingIndicator inline />}
        {!isLoading && sourceType === 'LE_Tour' && !offer && (
          <>{intl.formatMessage({
            id: '5uKgzfS7INKpT0iuNJH5',
            defaultMessage: 'Could not load offer.',
            description: 'Error message when a tour offer fails to load on the trip map',
          })}
          </>
        )}
      </Container>
    )
  },
)

export default TourSummaryCard
